<template>

    <form ref="questaoperguntaresposta-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="resposta">Resposta</label>
                <br />
                <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos/Audio</em>
                <textarea required v-model="model.resposta" v-htmleditor></textarea>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehCorreta" class="custom-control-input" v-model="model.ehCorreta">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Correta?</span>
                </label>
            </div>
        </div>
        <button type="button" class="btn btn-primary float-left" @click="onBack()">
            Voltar a criar respostas
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Editar</span>
        </button>
        <br />
        <br />
    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "questaoperguntaresposta-form-edit",
        mixins: [base],
        props: { questaoRespostaId: Number, questaoPerguntaId: Number },
        data: () => ({

            model: {},

            form: "questaoperguntaresposta-form-edit",

            resources: {
                edit: 'questaoperguntaresposta',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;
                model.questaoPerguntaId = this.questaoPerguntaId;
                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                    this.$emit('on-back', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
        mounted() {
            new Api(this.resources.edit).get({ questaoRespostaId: this.questaoRespostaId }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>

